<template>
    <div>
    <Drawer :mask-closable="true" @on-close="handleReset('placeOrderForm');reviewPage=false" class="demo-drawer-prime"
            title="Place Order"
            v-model="$parent.placeOrderDrawer" width="800">
        <Row v-show="!reviewPage">
            <Col :xs="{span:24}" style="padding-top: 10px">
                <Form :model="placeOrderForm" :rules="ruleValidate" label-position="top" ref="placeOrderForm">

                    <Row :gutter="10">
                        <Col span="12">
                            <FormItem prop="pickUpDate" label="Pickup Date">
                                <DatePicker type="date" v-model="placeOrderForm.pickUpDate" :options="disableDate"
                                            placeholder="Pickup Date" format="dd/MM/yyyy" style="width: 264px"></DatePicker>
                            </FormItem>
                        </Col>
                        <Col span="12">
                            <Row>
                            <FormItem prop="filterDealerCity" style="float: right">
                            <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: cityFilterDealer}"
                                         :debounce="500" :skip="skip.dealerSkip" fetch-policy="network-only">
                            <template slot-scope="{ result: { loading, error, data } }">
                            <div v-if="loading"> Loading...</div>
                            <div v-else-if="error"> Error Occured. {{error}}</div>
                            <div v-else>
                            <AutoComplete placeholder="Order City" placement="bottom" element-id="clientCity"
                                          v-model="placeOrderForm.filterDealerCity" style="width:200px" @on-search="onSearchCity($event, 'clientCity')">
                            <Option :key="index" v-for="(cityObj,index) in data?data.city:[]"
                             :label="cityObj.city" :value="cityObj.city">
                                <div @click="onSelectCity(cityObj, 'clientCity')" class="ivu-select-item-div">{{cityObj.city}}</div>
                            </Option>
                            </AutoComplete>
                            </div>
                            </template>
                            </ApolloQuery>
                            </FormItem>
                            </Row>
                            <Row>
                                <FormItem prop="dealerName">
                                <ApolloQuery :query="query_SEARCH_DEALER" :debounce="500" :skip="companySkip.dealerSkip"
                                :variables="{dealerFilter:dealerFilter, filterDealerCity:[{city: selectedClientCity}]}"
                                fetch-policy="network-only">
                                <template slot-scope="{ result: { loading, error, data } }">
                                <div v-if="loading"> Loading...</div>
                                <div v-else-if="error"> Error Occured. {{error}}</div>
                                <div v-else>
                                <AutoComplete placeholder="Search Client" @on-search="onSearchParty($event, 'clientParty')"
                                v-model="placeOrderForm.dealerName">
                                <Option :key="index" :value="companyObj.name" @click="assignCompanyObj('Dealer', companyObj)"
                                v-for="(companyObj,index) in data?data.company:[]" :label="companyObj.name">
                                <div @click="assignCompanyObj('Dealer', companyObj)" class="ivu-select-item-div">
                                {{companyObj.name}}
                                </div>
                                </Option>
                                </AutoComplete>
                                </div>
                                </template>
                                </ApolloQuery>
                                </FormItem>
                                <Col span="24" v-if="placeOrderForm.dealerObj" style="margin-top: -20px;margin-bottom: 12px;font-size: 14px;">
                                    {{this.placeOrderForm.dealerObj.address[0].add1?this.placeOrderForm.dealerObj.address[0].add1+' ,':''}}
                                    {{this.placeOrderForm.dealerObj.address[0].add2?this.placeOrderForm.dealerObj.address[0].add2+' ,':''}}
                                    {{this.placeOrderForm.dealerObj.address[0].area}}, {{this.placeOrderForm.dealerObj.address[0].city}},
                                    {{this.placeOrderForm.dealerObj.address[0].state}} - {{this.placeOrderForm.dealerObj.address[0].pincode}}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Divider></Divider>


                    <Row :gutter="24">
                        <Col span="12">
                            <Row>
                                <Col span="10">
                                    <h2>Pickup Location</h2>
                                </Col>
                                <Col span="14">
                                    <FormItem prop="filterpickupPartyCity">
                                        <ApolloQuery :query="query_EXCEPTIONAL_CITY_MANAGER_SEARCH_CITY" :variables="{cityFilter: cityFilterPickupParty}"
                                                     :debounce="500" :skip="skip.pickupSkip" fetch-policy="network-only">
                                            <template slot-scope="{ result: { loading, error, data } }">
                                                <div v-if="loading"> Loading...</div>
                                                <div v-else-if="error"> Error Occured. {{error}}</div>
                                                <div v-else>
                                                    <AutoComplete placeholder="Pickup City" @on-search="onSearchCity($event, 'pickupCity')"
                                                                  v-model="placeOrderForm.filterpickupPartyCity" element-id="pickupCity">
                                                        <Option :key="index" :value="cityObj.city"
                                                                v-for="(cityObj,index) in data?data.city:[]">
                                                           <div class="ivu-select-item-div" @click="onSelectCity(cityObj, 'pickupCity')">{{cityObj.city}}</div>
                                                        </Option>
                                                    </AutoComplete>
                                                </div>
                                            </template>
                                        </ApolloQuery>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="20">
                                <Col span="20">
                                    <FormItem label="Name of Pickup Point" prop="pickupPartyName">
                                        <ApolloQuery :query="query_SEARCH_PICKUPPARTY" :debounce="500" :skip="companySkip.pickupSkip" fetch-policy="network-only"
                                                     :variables="{pickupPartyFilter:pickupPartyFilter, filterpickupPartyCity:[{city: selectedPickupCity}]}">
                                            <template slot-scope="{ result: { loading, error, data } }">
                                                <div v-if="loading"> Loading...</div>
                                                <div v-else-if="error"> Error Occured. {{error}}</div>
                                                <div v-else>
                                                    <AutoComplete placeholder="Search Pickup Point" @on-search="onSearchParty($event, 'pickupParty')"
                                                                  v-model="placeOrderForm.pickupPartyName">
                                                        <Option :key="index" :value="companyObj.name" :label="companyObj.name"
                                                                v-for="(companyObj,index) in data?data.addressbookedcompany:[]">
                                                            <div @click="assignCompanyObj('PickupParty', companyObj)" class="ivu-select-item-div">{{companyObj.name}}</div>
                                                        </Option>
                                                    </AutoComplete>
                                                </div>
                                            </template>
                                        </ApolloQuery>
                                    </FormItem>
                                </Col>
                                <Col span="4" style="margin: 35px 0 0 0;text-decoration: underline;cursor: pointer">
                                    <div @click="startAddingCompany('pickup')">ADD</div>
                                </Col>
                                <Col span="24" v-if="placeOrderForm.pickupPartyObj" style="margin-top: -20px;margin-bottom: 12px;font-size: 14px;">
                                    {{this.placeOrderForm.pickupPartyObj.address[0].add1?this.placeOrderForm.pickupPartyObj.address[0].add1+' ,':''}}
                                    {{this.placeOrderForm.pickupPartyObj.address[0].add2?this.placeOrderForm.pickupPartyObj.address[0].add2+' ,':''}}
                                    {{this.placeOrderForm.pickupPartyObj.address[0].area}}, {{this.placeOrderForm.pickupPartyObj.address[0].city}},
                                    {{this.placeOrderForm.pickupPartyObj.address[0].state}} - {{this.placeOrderForm.pickupPartyObj.address[0].pincode}}
                                </Col>
                            </Row>

                            <!--<FormItem label="Area" prop="pickupPartyArea">-->
                                <!--<Input placeholder="Enter Area" v-model="placeOrderForm.pickupPartyArea"></Input>-->
                            <!--</FormItem>-->

                            <Row>
                                <Col span="20">
                                    <FormItem label="Marketing Contact" prop="marketingContact">
                                        <Select v-model="placeOrderForm.marketingContact">
                                            <Option v-for="contact in marketingContactArr" :value="contact.id" :label="contact.name + ' - ' + contact.mobile" :key="contact.id">
                                                <div @click="assignContact(contact, 'marketing')" class="ivu-select-item-div">
                                                    {{ contact.name }} - {{contact.mobile}}</div>
                                                </Option>
                                        </Select>
                                        <!--<Input v-model="placeOrderForm.marketingContact"></Input>-->
                                    </FormItem>
                                </Col>
                                <Col span="4" v-if="placeOrderForm.pickupPartyObj && placeOrderForm.pickupPartyObj.name">
                                    <Button type="primary" shape="circle" icon="ios-add" style="margin: 26px 0px 0 8px;" @click="openAddContactDialog('1')"></Button>
                                </Col>
                            </Row>

                            <Row>
                               <Col span="20">
                                   <FormItem label="Dispatch Contact" prop="dispatchContact">
                                       <Select v-model="placeOrderForm.dispatchContact">
                                           <Option v-for="contact in dispatchContactArr" :value="contact.id" :label="contact.name + ' - ' + contact.mobile" :key="contact.id">
                                               <div @click="assignContact(contact, 'dispatch')" class="ivu-select-item-div">
                                                   {{ contact.name }} - {{contact.mobile}}</div>
                                           </Option>
                                       </Select>

                                   </FormItem>
                               </Col>
                               <Col span="4" v-if="placeOrderForm.pickupPartyObj && placeOrderForm.pickupPartyObj.name">
                                   <Button type="primary" shape="circle" icon="ios-add" style="margin: 26px 0px 0 8px;" @click="openAddContactDialog('2')"></Button>
                               </Col>
                            </Row>

                        </Col>
                        <Col span="12">
                            <Row>
                                <Col span="10">
                                    <h2>Drop Location</h2>
                                </Col>
                                <Col span="14">
                                    <FormItem prop="filterDroppingCity">
                                        <ApolloQuery :query="query_EXCEPTIONAL_CITY_MANAGER_SEARCH_CITY" :variables="{cityFilter: cityFilterDropping}"
                                                     :debounce="500" :skip="skip.dropSkip" fetch-policy="network-only">
                                            <template slot-scope="{ result: { loading, error, data } }">
                                                <div v-if="loading"> Loading...</div>
                                                <div v-else-if="error"> Error Occured. {{error}}</div>
                                                <div v-else>
                                                    <AutoComplete placeholder="Dropping City" @on-search="onSearchCity($event, 'droppingCity')"
                                                                  v-model="placeOrderForm.filterDroppingCity" element-id="dropCity">
                                                        <Option :key="index" :value="cityObj.city"
                                                                v-for="(cityObj,index) in data?data.city:[]">
                                                            <div class="ivu-select-item-div" @click="onSelectCity(cityObj, 'droppingCity')">{{cityObj.city}}</div>
                                                        </Option>
                                                    </AutoComplete>
                                                </div>
                                            </template>
                                        </ApolloQuery>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row :gutter="20">
                                <Col span="20">
                                    <FormItem label="Name of Dropping Party" prop="droppingPartyName">
                                        <ApolloQuery :query="query_SEARCH_DROPPINGPARTY" :debounce="500" :skip="companySkip.dropSkip" fetch-policy="network-only"
                                                     :variables="{droppingPartyFilter:droppingPartyFilter, filterDroppingCity:[{city: selectedDroppingCity}]}">
                                            <template slot-scope="{ result: { loading, error, data } }">
                                                <div v-if="loading"> Loading...</div>
                                                <div v-else-if="error"> Error Occured. {{error}}</div>
                                                <div v-else>
                                                    <AutoComplete placeholder="Search Dropping Party" @on-search="onSearchParty($event, 'droppingParty')"
                                                                  v-model="placeOrderForm.droppingPartyName">
                                                        <Option :key="index" :value="companyObj.name" :label="companyObj.name"
                                                                v-for="(companyObj,index) in data?data.addressbookedcompany:[]">
                                                            <div @click="assignCompanyObj('DroppingParty', companyObj)" class="ivu-select-item-div">
                                                                {{companyObj.name}}
                                                            </div>
                                                        </Option>
                                                    </AutoComplete>
                                                </div>
                                            </template>
                                        </ApolloQuery>
                                    </FormItem>
                                </Col>
                                <Col span="4" style="margin: 35px 0 0 0;text-decoration: underline;cursor: pointer">
                                    <div @click="startAddingCompany('drop')">ADD</div>
                                </Col>
                                <Col span="24" v-if="placeOrderForm.droppingPartyObj" style="margin-top: -20px;margin-bottom: 12px;font-size: 14px;">
                                    {{this.placeOrderForm.droppingPartyObj.address[0].add1?this.placeOrderForm.droppingPartyObj.address[0].add1+' ,':''}}
                                    {{this.placeOrderForm.droppingPartyObj.address[0].add2?this.placeOrderForm.droppingPartyObj.address[0].add2+' ,':''}}
                                    {{this.placeOrderForm.droppingPartyObj.address[0].area}}, {{this.placeOrderForm.droppingPartyObj.address[0].city}},
                                    {{this.placeOrderForm.droppingPartyObj.address[0].state}} - {{this.placeOrderForm.droppingPartyObj.address[0].pincode}}
                                </Col>
                            </Row>

                   <!--         <div class="tl-dashboard-map" id="drop-location-map"></div>
                            <Row :gutter="10" style="padding: 14px 0px 0px 0px;margin: 0px 0px -35px 0;">
                                <Col span="12">
                                    <FormItem label="Latitude" prop="pickupParty_latitude">
                                    <Input v-model="placeOrderForm.pickupParty_latitude" type="number"></Input>
                                    </FormItem>
                                </Col>
                                <Col span="12">
                                    <FormItem label="Longitude" prop="pickupParty_longitude">
                                        <Input v-model="placeOrderForm.pickupParty_longitude" type="number"></Input>
                                    </FormItem>
                                </Col>
                            </Row>         -->
                        </Col>
                    </Row>


                    <Divider></Divider>
                    <Row :gutter="24" type="flex" justify="space-between">
<!--                        <Col span="16">-->
<!--                          <Row :gutter="24">-->
                            <Col span="12">
                            <FormItem label="Material" prop="material">
                                <RadioGroup v-model="placeOrderForm.material">
                                    <Radio label="Tiles"></Radio>
                                    <Radio label="Sanitary"></Radio>
                                    <Radio label="Other"></Radio>
                                </RadioGroup>
                            </FormItem>
                            </Col>

                            <Col span="12">
                              <FormItem label="Size" prop="materialSize">
                                <RadioGroup v-model="placeOrderForm.materialSize">
                                    <Radio style="text-transform: capitalize" :label="m" v-for="(m, index) in materialSizeOptions" :key="index"/>
                                </RadioGroup>
                            </FormItem>
                            </Col>
<!--                          </Row>-->

<!--                                <Row :gutter="10">-->
                                    <Col span="24">
                                      <Row :gutter="10">
                                        <Col span="6">
                                          <FormItem label="Quantity" prop="boxQuantity">
                                          <Input  v-model="placeOrderForm.boxQuantity" type="textarea" :rows="1"/>
                                          </FormItem>
                                        </Col>
                                        <Col span="4" style="margin: 26px 0 0 0">
                                          <FormItem prop="kgQuantity">
                                            <Input v-model="placeOrderForm.kgQuantity" type="number" @on-keydown="restrictCharacters($event)">
                                              <span slot="append">KG</span>
                                            </Input>
                                          </FormItem>
                                        </Col>
                                      </Row>
                                    </Col>


<!--                                </Row>-->


                          <Col span="12">
                            <FormItem label="Priority" prop="priority">
                                <RadioGroup v-model="placeOrderForm.priority">
                                    <Radio label="Normal"></Radio>
                                    <Radio label="High"></Radio>
                                    <Radio label="Low"></Radio>
                                </RadioGroup>
                            </FormItem>
                          </Col>

                          <Col span="10" pull="2">
                            <FormItem label="Special Offered Freight" prop="splOfferedFreight">
                                <Input type="number" v-model="placeOrderForm.splOfferedFreight"/>
                            </FormItem>
                          </Col>

                      <Col span="10">
                            <FormItem label="Notes" prop="note">
                                <Input type="textarea" :rows="4" placeholder="Enter note"
                                       v-model="placeOrderForm.note"></Input>
                            </FormItem>
                      </Col>

                      <Col span="10" pull="2">
                            <FormItem label="Freight Note" prop="splOfferedFreightNote">
                                <Input type="textarea" :rows="4" placeholder="Enter note"
                                       v-model="placeOrderForm.splOfferedFreightNote"></Input>
                            </FormItem>
                      </Col>
<!--                        </Col>-->
                    </Row>

                    <FormItem>
                        <Button @click="handleSubmit('placeOrderForm')" type="primary">Next</Button>
                        <Button @click="handleReset('placeOrderForm')" style="margin-left: 8px">Reset</Button>
                    </FormItem>


                </Form>
                <Modal v-model="addContactDialog" :title="'Add ' +
                 (contactForm.role == '1' ? 'Marketing ' : 'Dispatch ') + 'Contact'">
                    <Row>
                        <Col span="24">
                            <Form :model="contactForm" :rules="ruleValidate_contactForm" label-position="top" ref="contactForm">

                                <FormItem prop="name" label="Contact Name">
                                <Input v-model="contactForm.name" :maxlength="30"/>
                                </FormItem>
                                <FormItem prop="mobile" label="Mobile Number">
                                    <Input v-model="contactForm.mobile" type="number"/>
                                </FormItem>
                                <FormItem prop="email" label="Email">
                                    <Input v-model="contactForm.email"/>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                    <div slot="footer">
                        <Button @click="addContactDialog=false">Cancel</Button>
                        <Button color="primary" @click="handleAddContact('contactForm')" :loading="contactloading">
                            <span v-if="!contactloading">Add</span>
                            <span v-else>Loading...</span>
                        </Button>
                    </div>
                </Modal>
            </Col>
        </Row>

        <Row v-show="reviewPage">
            <Col :xs="{span:24}" style="padding-top: 10px">
              <Row><Col span="5">Pickup Date</Col>
                  <Col span="19"><strong>{{formatDate(placeOrderForm.pickUpDate)}}</strong></Col>
              </Row>
                <Divider></Divider>
               <Row>
                   <h2>Party/Dealer</h2><br/>
                   <Col span="5">Name of Client</Col>
                   <Col span="19" v-if="placeOrderForm.dealerObj&&placeOrderForm.dealerObj.name">
                       <strong>{{placeOrderForm.dealerObj.name}}</strong></Col>
                   <Col span="19" v-else>-</Col>
                   <Col span="5">Address</Col>
                   <Col span="19" v-if="placeOrderForm.dealerObj">
                       {{this.placeOrderForm.dealerObj.address[0].add1?this.placeOrderForm.dealerObj.address[0].add1+' ,':''}}
                       {{this.placeOrderForm.dealerObj.address[0].add2?this.placeOrderForm.dealerObj.address[0].add2+' ,':''}}
                       {{this.placeOrderForm.dealerObj.address[0].area}}, {{this.placeOrderForm.dealerObj.address[0].city}},
                       {{this.placeOrderForm.dealerObj.address[0].state}} - {{this.placeOrderForm.dealerObj.address[0].pincode}}
                   </Col>
                   <Col span="19" v-else>-</Col>
               </Row>
                <Divider></Divider>
                <Row>
                    <h2>Pickup Party</h2><br/>
                    <Col span="5">Name of Pickup Party</Col>
                    <Col span="19" v-if="placeOrderForm.pickupPartyObj&&placeOrderForm.pickupPartyObj.name">
                        <strong>{{placeOrderForm.pickupPartyObj.name}}</strong></Col>
                    <Col span="19" v-else>-</Col>
                    <Col span="5">Address</Col>
                    <Col span="19" v-if="placeOrderForm.pickupPartyObj">
                        {{this.placeOrderForm.pickupPartyObj.address[0].add1?this.placeOrderForm.pickupPartyObj.address[0].add1+' ,':''}}
                        {{this.placeOrderForm.pickupPartyObj.address[0].add2?this.placeOrderForm.pickupPartyObj.address[0].add2+' ,':''}}
                        {{this.placeOrderForm.pickupPartyObj.address[0].area}}, {{this.placeOrderForm.pickupPartyObj.address[0].city}},
                        {{this.placeOrderForm.pickupPartyObj.address[0].state}} - {{this.placeOrderForm.pickupPartyObj.address[0].pincode}}
                    </Col>
                    <Col span="19" v-else>-</Col>
                    <!--<Col span="5">Area</Col>-->
                    <!--<Col span="19" v-if="placeOrderForm.pickupPartyArea"><strong>{{placeOrderForm.pickupPartyArea}}</strong></Col>-->
                    <!--<Col span="19" v-else>-</Col>-->
                    <Col span="5">Marketing Contact</Col>
                    <Col span="19" v-if="placeOrderForm.marketingContactObj&&placeOrderForm.marketingContactObj.name">
                        <strong>{{placeOrderForm.marketingContactObj.name}}</strong></Col>
                    <Col span="19" v-else>-</Col>
                    <Col span="5">Dispatch Contact</Col>
                    <Col span="19" v-if="placeOrderForm.dispatchContactObj&&placeOrderForm.dispatchContactObj.name">
                        <strong>{{placeOrderForm.dispatchContactObj.name}}</strong></Col>
                    <Col span="19" v-else>-</Col>
                </Row>
                <Divider></Divider>
                <Row>
                    <h2>Dropping Party</h2><br/>
                    <Col span="5">Name of Dropping Party</Col>
                    <Col span="19" v-if="placeOrderForm.droppingPartyObj&&placeOrderForm.droppingPartyObj.name">
                        <strong>{{placeOrderForm.droppingPartyObj.name}}</strong></Col>
                    <Col span="19" v-else>-</Col>
                    <Col span="5">Address</Col>
                    <Col span="19" v-if="placeOrderForm.droppingPartyObj">
                        {{this.placeOrderForm.droppingPartyObj.address[0].add1?this.placeOrderForm.droppingPartyObj.address[0].add1+' ,':''}}
                        {{this.placeOrderForm.droppingPartyObj.address[0].add2?this.placeOrderForm.droppingPartyObj.address[0].add2+' ,':''}}
                        {{this.placeOrderForm.droppingPartyObj.address[0].area}}, {{this.placeOrderForm.droppingPartyObj.address[0].city}},
                        {{this.placeOrderForm.droppingPartyObj.address[0].state}} - {{this.placeOrderForm.droppingPartyObj.address[0].pincode}}
                    </Col>
                    <Col span="19" v-else>-</Col>
                </Row>
                <Divider></Divider>
                <Row>
                    <Col span="5">Material</Col>
                    <Col span="19"><strong>{{placeOrderForm.material}}</strong></Col>
                    <Col span="5">Quantity</Col>
                    <Col span="19"><strong>{{placeOrderForm.boxQuantity + ' Boxes'}}
                        , {{placeOrderForm.kgQuantity + ' KG'}}</strong></Col>
                    <Col span="5">Priority</Col>
                    <Col span="19"><strong>{{placeOrderForm.priority}}</strong></Col>
                    <Col span="5">Notes</Col>
                    <Col span="19" v-if="placeOrderForm.note"><strong>{{placeOrderForm.note}}</strong></Col>
                    <Col span="19" v-else>-</Col>
                    <Col span="5">Special Offered Freight</Col>
                    <Col span="19"><strong>₹ {{placeOrderForm.splOfferedFreight || 0}}</strong></Col>
                    <Col span="5">Freight Notes</Col>
                    <Col span="19" v-if="placeOrderForm.splOfferedFreightNote"><strong>{{placeOrderForm.splOfferedFreightNote}}</strong></Col>
                    <Col span="19" v-else>-</Col>
                </Row>

                <Button @click="placeOrder()" type="primary" :loading="loading">
                    <span v-if="!loading">Confirm</span>
                    <span v-else>Loading...</span>
                </Button>
                <Button @click="reviewPage=false" style="margin-left: 8px">Edit</Button>
            </Col>
        </Row>
    </Drawer>

    <company-drawer :initialCompanyType="initialCompanyType" ref="register-company-form"></company-drawer>
    </div>
</template>

<script>
    import CompanyDrawer from './RegisterCompanyDrawer'
    import {EXCEPTIONAL_CITY_MANAGER_SEARCH_CITY2, SEARCH_CITY2} from '../graphql/queries/territories'
    import {
        SEARCH_DEALER,
        SEARCH_PICKUPPARTY,
        GET_SINGLE_COMPANY,
        SEARCH_DROPPINGPARTY
    } from '../graphql/queries/companies'
    import {GET_CONTACTS_OF_ADDRESSBOOK} from '../graphql/queries/contacts'
    import {ADD_ORDER, ADD_ORDERDETAIL} from '../graphql/mutations/orders'
    import {ADD_CONTACT_TO_ADDRESSBOOK} from '../graphql/mutations/contacts'
    import {GET_LAST_ORDER} from '../graphql/queries/Orders'
    import moment from 'moment'
    import {Constants, generateUUID} from '../Constants/Constant'
    import {GET_CONTRACTORS} from "../graphql/queries/vehicle";
    import store from "../store";

    export default {
        apollo: {
            contacts: {
                query: GET_CONTACTS_OF_ADDRESSBOOK,
                variables () {
                    return {
                        partyId: this.placeOrderForm.pickupPartyObj.id
                            ? this.placeOrderForm.pickupPartyObj.id: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                    }
                },
                skip: true,
                result ({ data, loading }) {
                    let self = this;
                    if (!loading) {
                        this.marketingContactArr = [];
                        this.dispatchContactArr = [];
                        data.contacts.forEach(function (curnt) {
                            if (curnt.role == 1) {
                                self.marketingContactArr.push(curnt)
                            } else if (curnt.role == 2) {
                                self.dispatchContactArr.push(curnt)
                            }
                        })
                    }
                },
            }
        },

        name: 'PlaceOrderDrawer',
        components: {CompanyDrawer},
        data() {
            let self = this;
            return {
                userObj: JSON.parse(localStorage.getItem('tatkalorri')).userObj,
                editCompanyDrawer: false,
                initialCompanyType: '',
                addToAddressBookOnly: true,
                query_SEARCH_CITY: SEARCH_CITY2,
                query_EXCEPTIONAL_CITY_MANAGER_SEARCH_CITY: EXCEPTIONAL_CITY_MANAGER_SEARCH_CITY2,
                query_SEARCH_DEALER: SEARCH_DEALER,
                query_SEARCH_PICKUPPARTY: SEARCH_PICKUPPARTY,
                query_GET_CONTACTS_OF_ADDRESSBOOK: GET_CONTACTS_OF_ADDRESSBOOK,
                query_GET_SINGLE_COMPANY: GET_SINGLE_COMPANY,
                query_SEARCH_DROPPINGPARTY: SEARCH_DROPPINGPARTY,
                mutation_ADD_CONTACT_TO_ADDRESSBOOK: ADD_CONTACT_TO_ADDRESSBOOK,
                query_GET_LAST_ORDER: GET_LAST_ORDER,
                quantityType: 'boxes',
                disableDate: {disabledDate (date) {return date && date.valueOf() < Date.now() - 86400000;}},
                marketingContactArr: [],
                dispatchContactArr: [],
                placeOrderForm: {
                    pickUpDate: moment().format('DD/MM/YYYY'),
                    filterDealerCity: '',
                    dealerName: '',
                    dealerObj: '',
                    filterDroppingCity: '',
                    droppingPartyName: '',
                    droppingPartyObj: '',
                    filterpickupPartyCity: '',
                    pickupPartyName: '',
                    pickupPartyObj: '',
                    pickupPartyArea: '',
                    marketingContact: '',
                    marketingContactObj: '',
                    dispatchContact: '',
                    dispatchContactObj: '',
                    companyName: '',
                    mobile: '',
                    email: '',
                    latitude: '',
                    longitude: '',
                    material: null,
                    boxQuantity: '',
                    kgQuantity: 0,
                    priority: 'Normal',
                    note: '',
                    pickupParty_latitude: null,
                    pickupParty_longitude: null,
                    materialSize : null,
                    splOfferedFreight: 0,
                    splOfferedFreightNote: null
                },
                ruleValidate: {
                    pickUpDate: [{required: true, type: 'date', message: 'Please select Date', trigger: 'blur'}],
                    material: [{required: true, message: 'Please select the Material', trigger: 'blur'}],
                    boxQuantity: [{validator: self.validateBoxQty, trigger: 'change'}],
                    kgQuantity: [{validator: self.validateKgQty, trigger: 'change'}],
                    splOfferedFreight: [{validator: self.validateSplOfferedFreight, trigger: 'change'}],
                    priority: [{required: true, message: 'Please select Priority', trigger: 'blur'}],
                    materialSize: [{required: true, message: 'Please select Size', trigger: 'blur'}],
                    email: [{type: 'email', message: 'Incorrect email format', trigger: 'change'}]
                },
                addContactDialog: false,
                contactForm: {
                    name: '',
                    mobile: '',
                    email: '',
                    role: '',
                    clientId: ''
                },
                ruleValidate_contactForm: {
                    name:  [{required: true, message: 'Enter name', trigger: 'blur'}],
                    email: [{type: 'email', message: 'Incorrect email format', trigger: 'change'}],
                    mobile: [{validator: self.validateMobile, trigger: 'change'}]
                },
                reviewPage: false,
                lastOrderNum: '',
                map: null,
                selectedCityCode: 'SUR',
                contacts: null,
                cityFilterDealer: '%%',
                cityFilterDropping: '%%',
                cityFilterPickupParty: '%%',
                skip: {dealerSkip: true, pickupSkip: true, dropSkip: true}, //To Avoid calls at initial
             /* -- ↓ Assign value on selectEvent ↓ -- */
                selectedClientCity: '',
                selectedDroppingCity: '',
                selectedPickupCity: '',
             /* ----- x----- x----- x-------x ------- */
                companySkip: {dealerSkip: true, pickupSkip: true, dropSkip: true}, //To Avoid calls at initial
                dealerFilter: '%%',
                pickupPartyFilter: '%%',
                droppingPartyFilter: '%%',
                mapPriorityToId: {'Low': 0, 'Normal': 1, 'High': 2},
                loading: false,
                contactloading: false,
                materialSizeOptions: Constants.materialSizes
            }
        },
        computed: {},
        methods: {
            onSearchCity: function(val, str){
                if(str === 'clientCity') {
                    this.cityFilterDealer = '%' + val + '%';
                    this.skip.dealerSkip = false;
                } else if(str === 'droppingCity') {
                    this.cityFilterDropping = '%' + val + '%';
                    this.skip.dropSkip = false;
                } else if(str === 'pickupCity') {
                    this.cityFilterPickupParty = '%' + val + '%';
                    this.skip.pickupSkip = false;
                }
            },
            onSelectCity: function(val, str){
                if(str === 'clientCity') {
                    this.selectedClientCity = val.city;
                    this.selectedCityCode = val.shortCode
                    this.placeOrderForm.dealerName = '';       //Clear Company field on change City
                    this.placeOrderForm.dealerObj = '';
                    this.dealerFilter = '%%';
                    this.companySkip.dealerSkip = false;        //Auto load company dropdown on select City
                }else if(str === 'droppingCity') {
                    this.selectedDroppingCity = val.city;
                    this.placeOrderForm.droppingPartyName = '';       //Clear Company field on change City
                    this.placeOrderForm.droppingPartyObj = '';
                    this.droppingPartyFilter = '%%';
                    this.companySkip.dropSkip = false;                //Auto load company dropdown on select City
                }else if(str === 'pickupCity') {
                    this.selectedPickupCity = val.city;
                    this.placeOrderForm.pickupPartyName = '';       //Clear Company field on change City
                    this.placeOrderForm.pickupPartyObj = '';
                    this.pickupPartyFilter = '%%';
                    this.companySkip.pickupSkip = false;            //Auto load company dropdown on select City
                }
            },
            onSearchParty: function(val, str){
                if(str === 'clientParty'){
                    this.dealerFilter = '%' + val + '%';
                    this.companySkip.dealerSkip = false;
                } else if(str === 'droppingParty'){
                    this.droppingPartyFilter = '%' + val + '%';
                    this.companySkip.dropSkip = false;
                } else if(str === 'pickupParty'){
                    this.pickupPartyFilter = '%' + val + '%';
                    this.companySkip.pickupSkip = false;
                }
            },
            formatDate(date){
              return moment(date, 'ddd MMMM DD YYYY').format('DD-MM-YYYY')
            },
            generateMap(){
              var self = this;
              var element = document.getElementById('drop-location-map');
              var myLatLng =  new google.maps.LatLng(21.2065469, 72.8268008);
              var options = {
                  zoom: 12,
                  center: myLatLng,
                  mapTypeControl: false,
                  gestureHandling: 'greedy'
                 }
              this.map = new google.maps.Map(element, options);

              // Place a draggable marker on the map
               var marker = new google.maps.Marker({
                 position: myLatLng,
                 map: this.map,
                 draggable:true
                  });
              // Add a drag event on the marker
                google.maps.event.addListener(marker, 'dragend', function()
                {
                   self.placeOrderForm.pickupParty_latitude = marker.position.lat();
                   self.placeOrderForm.pickupParty_longitude = marker.position.lng();
                });
            },
            validateMobile(rule, value, callback){
                    if(value && value.toString().length !== 10) {
                        callback(new Error('Length Must be equal to 10 digit'))
                    } else {
                        callback()
                    }
            },
            validateBoxQty(rule, value, callback){
                if(!value && !this.placeOrderForm.kgQuantity){
                    return callback(new Error('Please enter Boxes/KG'))
                } else {
                    callback()
                }
            },
            validateKgQty(rule, value, callback){
                if(!value && !this.placeOrderForm.boxQuantity){
                    return callback(new Error('Please enter Boxes/KG'))
                }
                if(value && value <= 0) {
                    callback(new Error('Invalid Qty'))
                } else {
                    callback()
                }
            },
            validateSplOfferedFreight(rule, value, callback){
                if(value && value < 0) {
                    callback(new Error('Invalid Value'))
                } else {
                    callback()
                }
            },
            restrictCharacters(evt){
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if (charCode == 109 || charCode == 189 || charCode == 38 || charCode == 40) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            async getLastOrder(){
                 let response = await this.$apollo.query({
                   query: this.query_GET_LAST_ORDER,
                   fetchPolicy: "network-only"
                })
               if(response.data.orders.length){
                   this.lastOrderNum = response.data.orders[0].orderNumber;
               }else{
                   this.lastOrderNum = 'SUR20190522000';
               }
            },
            generateOrderNumber(){
              let orderNum = this.selectedCityCode + moment().format('YYYYMMDD');
              // let lastThreeDigits = parseInt(this.lastOrderNum.substr(this.lastOrderNum.length - 3)) + 1;
              let lastThreeDigits = parseInt(this.lastOrderNum.substr(11)) + 1;
              if(lastThreeDigits.toString().length == 1){
                  lastThreeDigits = '00' + lastThreeDigits
              }else if(lastThreeDigits.toString().length == 2){
                  lastThreeDigits = '0' + lastThreeDigits
              }
              return orderNum + lastThreeDigits;
            },
            startAddingCompany(str){
                if(str === 'pickup'){
                    this.initialCompanyType = '3a3248e1-f7a9-1982-1309-f9b6b780af40';
                    this.$refs['register-company-form'].companyRegistrationForm.userType = '3a3248e1-f7a9-1982-1309-f9b6b780af40';
                }else{
                    this.initialCompanyType = '';
                    this.$refs['register-company-form'].companyRegistrationForm.userType = '';
                }
                this.addToAddressBookOnly = true;
                this.$refs['register-company-form'].companyType_skip = false;
                this.editCompanyDrawer = true;
            },
            assignCompanyObj(companyType, companyObj){
                if(companyType == 'Dealer'){
                    this.placeOrderForm.dealerObj = companyObj;
                }else if(companyType == 'PickupParty'){
                    this.placeOrderForm.pickupPartyObj = companyObj;
                    this.$apollo.queries.contacts.skip = false;
                    this.$apollo.queries.contacts.refetch();
                }else if(companyType == 'DroppingParty'){
                    this.placeOrderForm.droppingPartyObj = companyObj;
                }

            },
            assignContact(contactObj, contactType) {
                if (contactType == 'marketing') {
                    this.placeOrderForm.marketingContactObj = contactObj;
                } else if (contactType == 'dispatch') {
                    this.placeOrderForm.dispatchContactObj = contactObj;
                }
            },
            openAddContactDialog(role){
              this.$refs['contactForm'].resetFields()
              this.contactForm.role = role;
              this.contactForm.clientId = this.placeOrderForm.pickupPartyObj.id;
              this.addContactDialog = true;
            },
            handleAddContact(name){
                this.contactloading = true;
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.addContactToAddressBook();
                    } else {
                        this.$Message.error('Fail!')
                        this.contactloading = false
                    }
                })
            },
            async addContactToAddressBook(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_CONTACT_TO_ADDRESSBOOK,
                    variables: {
                        id: generateUUID(),
                        name: this.contactForm.name,
                        mobile: this.contactForm.mobile,
                        email: this.contactForm.email,
                        role: parseInt(this.contactForm.role),
                        clientid: this.contactForm.clientId
                    }
                })
                if(response.data.insert_addressbookedcontacts.returning[0].id){
                    this.$Message.success('Contact added Successfully!');
                    this.addContactDialog = false;
                    this.contactloading = false
                    this.$apollo.queries.contacts.refetch();
                }
            },
            handleSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.reviewPage = true;
                    } else {
                        this.$Message.error('Fail!')
                    }
                })
            },
            handleReset(name) {
                this.$refs[name].resetFields()
                this.placeOrderForm.dealerObj = '';
                this.placeOrderForm.droppingPartyObj = '';
                this.placeOrderForm.pickupPartyObj = '';
                this.placeOrderForm.marketingContactObj = '';
                this.placeOrderForm.dispatchContactObj = '';
                this.companySkip =  {dealerSkip: true, pickupSkip: true, dropSkip: true}
                this.dealerFilter = '%%'
                this.pickupPartyFilter = '%%'
                this.droppingPartyFilter = '%%'
                this.skip = {dealerSkip: true, pickupSkip: true, dropSkip: true}
                this.cityFilterDealer = '%%'
                this.cityFilterDropping = '%%'
                this.cityFilterPickupParty = '%%'

            },
            async placeOrder() {
                this.loading = true;
                let self = this;
     /* ---------------- GET LAST ORDER NUMBER ----------------- */
                // let res = await this.$apollo.query({
                //     query: this.query_GET_LAST_ORDER,
                //     variables: {
                //         // createdAt: moment().format('YYYY-MM-DD')
                //         createdAt: moment().format('YYYY-MM-DDT00:00:00+05:30')
                //     },
                //     fetchPolicy: "network-only"
                // })
                // if(res.data.orders.length){
                //     this.lastOrderNum = res.data.orders[0].orderNumber;
                // }else{
                //     this.lastOrderNum = 'SUR20190522000';
                // }
                // let orderNumber = this.generateOrderNumber()
    /* ---------------x---------------x--------------x------------ */

                let clientId = self.placeOrderForm.dealerObj.id?self.placeOrderForm.dealerObj.id: '';
                let pickuppartyid = self.placeOrderForm.pickupPartyObj.id?self.placeOrderForm.pickupPartyObj.id:'';
                let droppingpartyid = self.placeOrderForm.droppingPartyObj.id?self.placeOrderForm.droppingPartyObj.id:'';
                let orderRequest = {
                    pickupDate: moment(self.placeOrderForm.pickUpDate, 'ddd MMMM DD YYYY').format('YYYY-MM-DD'),
                    id: generateUUID(),
                    orderNumber: generateUUID(),
                    createdAt: moment().format(),
                    updatedAt: moment().format(),
                    clientid: clientId,
                    clientobject: {
                        id: self.placeOrderForm.dealerObj.id,
                        name: self.placeOrderForm.dealerObj.name,
                        mobile: self.placeOrderForm.dealerObj.mobile,
                        email: self.placeOrderForm.dealerObj.email,
                        address: self.placeOrderForm.dealerObj.address
                    },
                    pickuppartyid: pickuppartyid,
                    pickuppartyobject: {
                        id: self.placeOrderForm.pickupPartyObj.id,
                        name: self.placeOrderForm.pickupPartyObj.name,
                        mobile: self.placeOrderForm.pickupPartyObj.mobile,
                        email: self.placeOrderForm.pickupPartyObj.email,
                        address: self.placeOrderForm.pickupPartyObj.address,
                        latitude: self.placeOrderForm.pickupParty_latitude,
                        longitude: self.placeOrderForm.pickupParty_longitude,
                        mktgContactId: self.placeOrderForm.marketingContact,
                        dispatchContactId: self.placeOrderForm.dispatchContact
                    },
                    droppingpartyid: droppingpartyid,
                    droppingpartyobject: {
                        id: self.placeOrderForm.droppingPartyObj.id,
                        name: self.placeOrderForm.droppingPartyObj.name,
                        mobile: self.placeOrderForm.droppingPartyObj.mobile,
                        email: self.placeOrderForm.droppingPartyObj.email,
                        address: self.placeOrderForm.droppingPartyObj.address
                    },
                    materials: {type: self.placeOrderForm.material,
                        boxes: self.placeOrderForm.boxQuantity,
                        kg: self.placeOrderForm.kgQuantity ? parseInt(self.placeOrderForm.kgQuantity) : 0,
                        originalBoxes: self.placeOrderForm.boxQuantity,
                        originalKg: self.placeOrderForm.kgQuantity ? parseInt(self.placeOrderForm.kgQuantity) : 0,
                    },
                    note: self.placeOrderForm.note,
                    priority: self.mapPriorityToId[self.placeOrderForm.priority],
                    lastStageUpdatedOn : moment().format(),
                    lastStageUpdatedBy : this.userObj.user.id,
                    internalstatus: '154dcbf5-2ee8-b60d-9f0d-3709944337bd',
                    externalstatus: '92dda220-d5c9-16ef-261d-6cfc92341fda',
                    cityCode: this.selectedCityCode
                }
                let response = await this.$apollo.mutate({
                    mutation: ADD_ORDER,
                    variables: {orderObj: orderRequest},
                })
                if(response.data.insert_orders.affected_rows){
                    this.insertOrderDetail(orderRequest.id)
                }else{
                    self.$Message.error({content:'Fail to place Order!. Please confirm again to place Order',
                        duration: 10, closable: true});
                    self.loading = false
                }
            },
            async insertOrderDetail(orderId){
              let mappedAreas = this.$store.state.mappedAreas
                let orderDetailRequest = {
                    id: generateUUID(),
                    orderId: orderId,
                    dropPoint: { add1: '', add2: '', area: '', city: '', email: '', state: '',
                        mobile: '', pincode: '', dropPartyId: '', dropPartyName: ''},
                    pickupPoint: { add1: '', add2: '', area: '', city: '', email: '', state: '',
                        mobile: '', pincode: '', pickupPartyId: '', pickupPartyName: ''},
                    orderReadiness: { pickupDate: '', isOrderReady: false},
                    lrObject: { lrName: '', islrReady: false, isEmailSent: false},
                    pickupConfirmation: 'Awaiting',
                    materialSize: this.placeOrderForm.materialSize,
                    splOfferedFreight: this.placeOrderForm.splOfferedFreight || 0,
                    splOfferedFreightNote: this.placeOrderForm.splOfferedFreightNote || null,
                    pickupAreaGroup: mappedAreas[this.placeOrderForm.pickupPartyObj.address[0].area.toLowerCase()] || null,
                    dropAreaGroup: mappedAreas[this.placeOrderForm.droppingPartyObj.address[0].area.toLowerCase()] || null,
                }
                let response = await this.$apollo.mutate({
                    mutation: ADD_ORDERDETAIL,
                    variables: {orderDetailObj: orderDetailRequest},
                })
                if(response.data){
                    this.$Message.success('Order placed successfully!');
                    this.handleReset('placeOrderForm');
                    this.reviewPage = false;
                    this.$parent.placeOrderDrawer = false;
                    this.loading = false
                }
            }
        },
       created(){
           //     document.onkeydown = evt => {
           //         evt = evt || window.event;
           //         if (evt.keyCode == 13) {
           //             console.log('enter key fired', evt.target)
           //         }
           //     };
       },
        mounted(){
            // this.generateMap();
            document.querySelector("#clientCity").setAttribute("autocomplete", "new-password");
            document.querySelector("#pickupCity").setAttribute("autocomplete", "new-password");
            document.querySelector("#dropCity").setAttribute("autocomplete", "new-password");
        }
    }
</script>

<style scoped>
   /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }


   /deep/ .ivu-date-picker-cells{
    width: 259px !important;
    }

    .ivu-date-picker-cells span{
        width: 37px !important;
        margin: 0;
        font-size: 15px;
    }
    .tl-dashboard-map{
        width: 100%;
        height: 234px;
        background: gray;
    }

   /deep/ .ivu-auto-complete.ivu-select-dropdown{
        max-height: 200px !important;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
    }
    /deep/.ivu-auto-complete.ivu-select-dropdown{
        max-width: 400px;
        overflow-x: hidden;
        left: 0px !important;
        text-overflow: ellipsis;
    }
</style>
